export const PERFORMANCE_MONITOR_PARAMS = [
  'version',
  'id',
  'sequence',
  'measure',
  'uuid',

  'first_render_duration',
  'first_render_name',
  'last_render_duration',
  'last_render_name',
  'shortest_render_duration',
  'shortest_render_name',
  'shortest_render_duration_inclusive',
  'shortest_render_name_inclusive',
  'longest_render_duration',
  'longest_render_name',
  'longest_render_duration_inclusive',
  'longest_render_name_inclusive',
  'average_render_duration',
  'render_count',
  'render_count_inclusive',

  'first_track_duration',
  'first_track_name',
  'last_track_duration',
  'last_track_name',
  'shortest_track_duration',
  'shortest_track_name',
  'shortest_track_duration_inclusive',
  'shortest_track_name_inclusive',
  'longest_track_duration',
  'longest_track_name',
  'longest_track_duration_inclusive',
  'longest_track_name_inclusive',
  'average_track_duration',
  'track_count',
  'track_count_inclusive',

  'start_reason',
  'stop_reason',
  'pending_tracks',

  'duration_exclusive',
  'duration_inclusive',

  'elapsed_start',
  'elapsed_end',

  'data',
] as const;

export type PerformanceMonitorParams = Record<
  (typeof PERFORMANCE_MONITOR_PARAMS)[number],
  unknown
>;
